import Chord from "@/module/chord";
import chordTranspose from "@/module/chordTranspose";

var SongDetailMixin = {
	methods: {
		songContent() {
			var content = this.currentSong.content;

			content = content.replace(/\[([^\]]*),([^\]]*)]/g, m => m.replace(/,/g, "]["));
			content = content.replace(/\[([^\]]+)]/g, (match, chordString) => {
				var chord = Chord.parse(chordString);
				if (chord === null) {
					return "[" + chordString + "]";
				}
				return "[" + chordTranspose.transpose(chord, "transpose" in this.currentSong ? this.currentSong.transpose : 0).toString() + "]";
			});

			content = content
				.replace(new RegExp(/\n\n/, 'g'), "</span></p><p><span class='line'>")
				.replace(new RegExp(/\n/, 'g'), "</span><span class='line'>")
				.replace(new RegExp("\\[", 'g'), "<span class='chord'>")
				.replace(new RegExp("]", 'g'), "</span>");

			return "<p><span class='line'>" + content + "</span></p>";
		},
		processChords() {
			Array.from(document.getElementsByClassName("chord")).map(chord => {
				chord.parentElement.classList.add("with-chords");
				chord.parentElement.parentElement.classList.add("with-chords");

				var nextChord = chord.nextSibling;
				if (nextChord !== null) {
					if (nextChord.className !== "chord") {
						nextChord = nextChord.nextSibling;
					}
					if (nextChord !== null && nextChord.className === "chord") {
						nextChord.style.marginLeft = 0;
						if (chord.offsetTop === nextChord.offsetTop) {
							var collisionWidth = (chord.offsetLeft + chord.clientWidth) - nextChord.offsetLeft;
							if (collisionWidth > 0) {
								nextChord.style.marginLeft = collisionWidth + 10 + "px";
							}
						}
					}
				}
			});
		}
	},
	mounted() {
		document.addEventListener("ProcessChords", this.processChords);
	},
	destroy() {
		document.removeEventListener("ProcessChords", this.processChords);
	},
};


export { SongDetailMixin };
